import React from 'react';
const Footer = ({ style = {} }) => {
	return (
		<footer
			style={style}
			className="WpdContentAreaFooter"
		>
			<p className="WpdColorSecondary">
				Copyright &copy; 2011 - {new Date().getFullYear()} |{' '}
				<a
					href="https://wpdeveloper.com"
					className="WpdColorInfo"
				>
					WPDeveloper.com
				</a>{' '}
				| 124 Broadkill Rd #599 Milton, DE 19968
			</p>
		</footer>
	);
};

export default Footer;
